import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import auto from "chart.js/auto";
import {
  API_USER,
  BRANCH_ADMIN,
  BRANCH_CONSULTANT,
  END_USER,
  INTERNAL_ADMIN,
  bGId,
} from "common/constants/constants";
import { pageSize } from "common/constants/constants";
import {
  MANAGE_BRANCH_DOCUMENT,
  MANAGE_CONSULTANT,
  MANAGE_EG_ADMIN,
  MANAGE_END_USERS,
  VIEW_CONSULTANT,
  VIEW_EG_ADMIN,
  VIEW_END_USERS,
} from "common/constants/permissionKeys";
import { MANAGE_USERS } from "common/constants/permissionKeys";
import { scrolToTop } from "common/utils/utilities";
import BranchDataStatusModal from "components/common/BranchDataStatusModal/BranchDataStatusModal";
import BranchModalWrapper from "components/common/branchModalWrapper/BranchModalWrapper";
import TableCommon from "components/common/dynamicTable/DynamicTable";
import Loader from "components/common/loader/Loader";
import NoDataFound from "components/common/noDataFound/NoDataFound";
import Paginate from "components/common/pagination/Paginate";
import ParentBtn from "components/common/parentButton/ParentButton";
import { usePermission } from "hooks/permission/usePermission";
import { getRoleFromLocalStorage } from "utils/Utils";
import { checkRole } from "utils/Utils";
import { getProductList } from "services/ProductsServices";
import { getUsers } from "services/UserManagementServices";
import { getAllBankslist, downloadBankData } from "services/bankServices";
import { getAllBranchesNames, getAllBranchlist } from "services/bankServices";
import { getBranchDataStatus } from "services/branchServices";

import InviteUser from "./InviteUser";
import EgUserActionBar from "./egUser/EgUserActionBar";
import EndUserActionBar from "./endUser/EndUser";
import "./userManagement.scss";
import VdsUserActionBar from "./vdsUser/VdsUserActionBar";
import { useTranslation } from "react-i18next";
import DownloadUserData from "./../common/downloadUserData/DownloadUserData";
import DownloadUserDataModal from "./../common/downloadUserData/DownloadUserDataModal";
import { getCurrentDate } from "utils/Utils";
import ApiUserActionBar from "./apiUser/ApiUser";

const UserListing = () => {
  const { t, i18n } = useTranslation();
  const bankGroupId = bGId;
  const [refresh, setRefresh] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(() => getRoleFromLocalStorage());
  const [userList, setUserList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [isBranchLoading, setBranchLoading] = useState(false);
  const [branchList, setBranchList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [branchDataStatus, setBranchDataStatus] = useState(false);
  const [show, setShow] = useState(false);
  const [downloadDataLoading, setDownloadDataLoading] = useState(false);
  const rolesList = [
    {
      name: BRANCH_ADMIN,
      translatedValue: "EG Admin",
      roleId: "302b630d-22dc-4304-9225-6884d41cca7a",
    },
    {
      name: BRANCH_CONSULTANT,
      translatedValue: "EG Consultant",
      roleId: "07c5abe9-2477-459f-a432-be10a275f620",
    },
    {
      name: END_USER,
      translatedValue: "End User",
      roleId: "1dcd5e01-743e-4ef6-a9d0-dffa336967d5",
    },
    {
      name: API_USER,
      translatedValue: "API User",
      roleId: "2dcd5e01-743e-4ef6-a9d0-dffa336967d5",
    },
  ];
  const [filters, setFilters] = useState({
    orderType: "DESC",
    searchString: "",
    orderBy: "",
    bankId: "",
    branchId: "",
    products: [],
    roles: [],
    isActive: "",
  });
  const commonHeadings = [
    t("user-name"),
    t("email"),
    t("last-activity"),
    t("status"),
    t("role"),
    t("actions"),
  ];
  const [tableHeading, setTableHeading] = useState(() => {
    if ([INTERNAL_ADMIN].includes(activeTab)) {
      return commonHeadings;
    } else if ([BRANCH_ADMIN].includes(activeTab)) {
      commonHeadings.splice(
        commonHeadings.length - 1,
        0,
        t("products-assigned")
      );
      return commonHeadings;
    } else if ([BRANCH_CONSULTANT].includes(activeTab)) {
      commonHeadings.splice(
        commonHeadings.length - 1,
        0,
        t("products-assigned"),
        t("consultant")
      );
      return commonHeadings;
    } else if ([API_USER].includes(activeTab)) {
      commonHeadings.splice(
        commonHeadings.length - 1,
        0,
        t("organization-name")
      );
      return commonHeadings;
    }
  });
  const [orderByList, setOrderByList] = useState(
    JSON.parse(localStorage.getItem("users")).map((elem) => {
      return { value: elem.key, name: t("users-list-sort." + elem.key) };
    })
  );

  const { checkPermission } = usePermission();

  const permissionToManageEA = checkPermission(MANAGE_EG_ADMIN);
  const permissionToManageEC = checkPermission(MANAGE_CONSULTANT);
  const permissionToManageEU = checkPermission(MANAGE_END_USERS);
  const permissionToViewEA = checkPermission(VIEW_EG_ADMIN);
  const permissionToViewEC = checkPermission(VIEW_CONSULTANT);
  const permissionToViewEU = checkPermission(VIEW_END_USERS);
  const permissionToManageBranchDocument = checkPermission(
    MANAGE_BRANCH_DOCUMENT
  );
  const permissionToManageUsers = checkPermission(MANAGE_USERS);

  const [pagination, setPagination] = useState({});

  const handleRefresh = () => {
    setRefresh((pre) => !pre);
  };

  const handleTableHeader = (key) => {
    if (key === INTERNAL_ADMIN) {
      setTableHeading(commonHeadings);
    } else if ([BRANCH_ADMIN].includes(key)) {
      commonHeadings.splice(
        commonHeadings.length - 1,
        0,
        t("products-assigned")
      );
      setTableHeading(commonHeadings);
    } else if ([BRANCH_CONSULTANT].includes(key)) {
      commonHeadings.splice(
        commonHeadings.length - 1,
        0,
        t("first-payment"),
        t("products-assigned"),
        t("consultant")
      );
      setTableHeading(commonHeadings);
    } else if ([API_USER].includes(key)) {
      commonHeadings.splice(
        commonHeadings.length - 4,
        0,
        t("organization-name")
      );
      setTableHeading(commonHeadings);
    }
  };

  const handleTab = (key) => {
    setActiveTab(key);
    handleTableHeader(key);
    setPagination((pre) => {
      return { currentPage: 1 };
    });
    handleResetFilters();
  };

  const handleChangeFilters = (key, value) => {
    setPagination((pre) => {
      return { ...pre, currentPage: 1 };
    });
    if (key === "bankId") {
      setFilters((pre) => {
        return { ...pre, bankId: value, branchId: "" };
      });
      setBranchList([]);
      handleRefresh();
    } else if (key == "status") {
      setFilters((pre) => {
        return { ...pre, status: value };
      });
    } else {
      setFilters((pre) => {
        let obj = { ...pre };
        obj[key] = value;
        return obj;
      });
      handleRefresh();
    }
  };

  const handleNextPage = (data) => {
    const { selected } = data;
    setPagination((pre) => {
      return { ...pre, currentPage: selected + 1 };
    });
    handleRefresh();
  };
  const roles = {
    IA: "%23IA",
    EA: "%23EA",
    EC: "%23EC",
    EU: "%23EU",
    AU: "%23AU",
  };
  const getRoleFromTab = (activeTabKey) => {
    let userRole = "";
    if (activeTabKey === INTERNAL_ADMIN) {
      userRole = roles.IA;
    } else if (activeTabKey === BRANCH_ADMIN) {
      if (permissionToViewEC && permissionToViewEA) {
        userRole = `${roles.EA},${roles.EC}`;
      } else if (permissionToViewEC) {
        userRole = roles.EC;
      } else if (permissionToViewEA) {
        userRole = roles.EA;
      }
    } else if (activeTabKey === BRANCH_CONSULTANT) {
      userRole = roles.EU;
    } else if (activeTabKey === API_USER) {
      userRole = roles.AU;
    }
    return userRole;
  };
  const getUserList = async (activeTabKey) => {
    let userRole = getRoleFromTab(activeTabKey);
    if (filters.roles.length > 0) {
      userRole = "";
      filters.roles.forEach((el, i) => {
        userRole += `${i > 0 ? "," : ""}` + "%23" + el.substring(1);
      });
    }
    scrolToTop();
    let params = {
      role: userRole,
      pageNumber: pagination.currentPage || 1,
      pageSize,
      filter: "",
      ...filters,
    };
    setIsLoading(true);
    let result = await getUsers(params);
    if (result?.success) {
      const { totalCount, pageSize, totalPages, currentPage, items } =
        result.payLoad;
      if (!items || items.length === 0) {
        setIsLoading(false);
        setIsEmpty(true);
      } else {
        setIsEmpty(false);
        setUserList(items);
        setPagination({ totalCount, pageSize, totalPages, currentPage });
      }
    } else if (!result?.status && !result?.success) {
      setIsEmpty(true);
    }
    setIsLoading(false);
  };
  const downloadUserData = async (activeTab) => {
    const bankId = localStorage.getItem("bankId");
    let response = await downloadBankData(
      bankGroupId,
      bankId,
      activeTab == "#EA"
        ? filters.roles.join(",").replace(/#/g, "%23")
        : "%23EUUser",
      filters
    );
    if (response?.status == 200) {
      const url = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      let fileProducts = "";
      filters.products?.forEach((el) => {
        fileProducts += `${el.replace("%23", " ").replace(/Gecco/g, "Gecco₂")}`;
      });
      link.setAttribute(
        "download",
        (activeTab == "#EA"
          ? t("users-data-file-name-consultant")
          : t("users-data-file-name")) +
          fileProducts +
          " " +
          t("users-data-file-name-from") +
          " " +
          getCurrentDate() +
          ".xlsx"
      );
      document.body.appendChild(link);
      link.click();
      setDownloadDataLoading(false);
    }
  };

  const getBanksList = async () => {
    let result = await getAllBankslist(bankGroupId);
    if (result?.success) {
      let list = result?.payLoad?.map((item) => {
        return { value: item.bankId, name: item.bankName };
      });
      setBankList(list);
    }
  };
  const getProductsList = async () => {
    const result = await getProductList();
    setProductList(result?.payLoad?.items);
  };
  const getBranchesNames = async () => {
    setBranchLoading(true);
    let result = await getAllBranchesNames(bankGroupId, filters.bankId);
    if (result?.success) {
      let list = result?.payLoad?.map((item) => {
        return { value: item.branchId, name: item.branchName };
      });
      setBranchList(list);
      setBranchLoading(false);
    }
  };

  const checkBranchDataStatus = async () => {
    const branchId = localStorage.getItem("branchId");
    const bankId = localStorage.getItem("bankId");
    const pathIds = {
      branchId,
      bankId,
      bankGroupId,
    };
    const result = await getBranchDataStatus(pathIds);
    if (result.success) {
      setBranchDataStatus(result.payLoad.branchProductDetail);
    }
  };

  const handleResetFilters = () => {
    setFilters({
      orderType: "DESC",
      searchString: "",
      orderBy: "",
      bankId: "",
      branchId: "",
      roles: [],
      products: [],
    });
  };

  useEffect(() => {
    const handleLanguageChange = () => {
      setOrderByList(
        JSON.parse(localStorage.getItem("users")).map((elem) => {
          return { value: elem.key, name: t("users-list-sort." + elem.key) };
        })
      );
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [i18n]);

  useEffect(() => {
    getProductsList();
    getBanksList();
    (checkRole() === BRANCH_ADMIN || checkRole() === BRANCH_CONSULTANT) &&
      checkBranchDataStatus();
  }, []);
  useEffect(() => {
    if (filters.bankId) {
      getBranchesNames();
    }
  }, [filters.bankId]);
  useEffect(() => {
    getUserList(activeTab);
  }, [
    filters.bankId,
    filters.branchId,
    filters.orderType,
    filters.orderBy,
    filters.searchString,
    filters.roles,
    filters.status,
    refresh,
  ]);

  const showAddButton = true;

  const handleClose = () => {
    setShow(false);
  };

  const inviteUserEAHandler = () => {
    !branchDataStatus && setShow(true);
  };

  const loggedInRole = {
    internalAdminLoggedIn: () => checkRole() === INTERNAL_ADMIN,
    egAdminLoggedIn: () => checkRole() === BRANCH_ADMIN,
  };

  const showInviteUserButton = () =>
    loggedInRole.egAdminLoggedIn ? permissionToManageBranchDocument : true;
  const renderEGUsersTab = () => {
    if (
      (permissionToViewEA ||
        permissionToManageEA ||
        permissionToViewEC ||
        permissionToManageEC) &&
      [INTERNAL_ADMIN, BRANCH_ADMIN, BRANCH_CONSULTANT, API_USER].includes(
        activeTab
      )
    ) {
      return (
        <li
          className={activeTab === BRANCH_ADMIN ? "active" : ""}
          onClick={() => handleTab(BRANCH_ADMIN)}
        >
          {t("eg-users")}
        </li>
      );
    }
  };
  const renderAPIUsersTab = () => {
    if (
      loggedInRole.internalAdminLoggedIn() &&
      [
        INTERNAL_ADMIN,
        BRANCH_ADMIN,
        BRANCH_CONSULTANT,
        END_USER,
        API_USER,
      ].includes(activeTab)
    ) {
      return (
        <li
          className={activeTab === API_USER ? "active" : ""}
          onClick={() => handleTab(API_USER)}
        >
          {t("api-user")}
        </li>
      );
    }
  };
  const renderENDUsersTab = () => {
    if (
      [BRANCH_ADMIN, BRANCH_CONSULTANT, API_USER].includes(activeTab) &&
      (permissionToViewEU || permissionToManageEU) &&
      !loggedInRole.internalAdminLoggedIn()
    ) {
      return (
        <li
          className={activeTab === BRANCH_CONSULTANT ? "active" : ""}
          onClick={() => handleTab(BRANCH_CONSULTANT)}
        >
          {t("end-users")}
        </li>
      );
    }
  };
  const renderVDSUsersTab = () => {
    if (
      [INTERNAL_ADMIN, BRANCH_ADMIN, BRANCH_CONSULTANT, API_USER].includes(
        activeTab
      ) &&
      getRoleFromLocalStorage() === "#IA"
    ) {
      return (
        <li
          className={activeTab === INTERNAL_ADMIN ? "active" : ""}
          onClick={() => handleTab(INTERNAL_ADMIN)}
        >
          {t("vds-user")}
        </li>
      );
    }
  };
  const renderInviteUserButton = () => {
    if (
      ((permissionToViewEA ||
        permissionToManageEA ||
        permissionToViewEC ||
        permissionToManageEC) &&
        permissionToManageUsers &&
        [BRANCH_ADMIN, API_USER].includes(activeTab) &&
        showInviteUserButton()) ||
      ((permissionToViewEU || permissionToManageEU) && permissionToManageUsers)
    ) {
      return (
        <InviteUser
          inviteUserHandler={
            !loggedInRole.internalAdminLoggedIn() && inviteUserEAHandler
          }
          branchDataStatus={true}
          activeTab={activeTab}
        />
      );
    }
  };

  return (
    <div className="tabs ">
      <div className="custom-breadcrumbs ">
        <span className="breadcrumbs-item ">{t("user-management")}</span>
      </div>
      <div className="custom-tabs-container">
        <ul
          className={`${isLoading ? "pe-none" : "pe-auto"
            } tabs-nav-custom text-uppercase m-0 position-relative`}
        >
          {renderVDSUsersTab()}
          {renderEGUsersTab()}
          {/* {renderAPIUsersTab()} */}
          {renderENDUsersTab()}

          <div
            className="pt-1 end-0 position-absolute row"
            style={{ width: "35%" }}
          >
            <div className="col-md-7 download-bills">
              {loggedInRole.egAdminLoggedIn() && (
                <div className="pl-5">
                  {/* //{activeTab === END_USER && ( */}
                  <DownloadUserData
                    buttonName={t("download-user-data")}
                    isLoading={downloadDataLoading}
                    btnHandler={() => {
                      setDownloadDataLoading(true);
                      downloadUserData(activeTab);
                    }}
                  />
                  {/* )}{" "} */}
                </div>
              )}
            </div>
            <div className="col-md-5">{renderInviteUserButton()}</div>
          </div>
        </ul>
        <div className="tab-body">
          {activeTab === INTERNAL_ADMIN && (
            <>
              <VdsUserActionBar
                handleChange={handleChangeFilters}
                handleSubmit={handleRefresh}
                orderByList={orderByList}
                filters={filters}
                resetFilters={handleResetFilters}
                searchPlaceholder={t("user-name")}
              />
              {isLoading ? (
                <Loader />
              ) : !isEmpty ? (
                <>
                  <TableCommon
                    heading={tableHeading}
                    name={activeTab}
                    body={userList}
                    tableStyle={{
                      minHeight: "40vh",
                      maxHeight: "40vh",
                    }}
                    permissionToEdit={false}
                  />
                  <Paginate
                    totalPages={pagination.totalPages}
                    handleNextPage={handleNextPage}
                    currentPage={pagination.currentPage}
                  />
                </>
              ) : (
                <NoDataFound />
              )}
            </>
          )}
          {activeTab === API_USER && (
            <>
              <ApiUserActionBar
                handleChange={handleChangeFilters}
                handleSubmit={handleRefresh}
                orderByList={orderByList}
                bankList={bankList}
                productList={productList}
                rolesList={rolesList.filter((elem) => elem.name === API_USER)}
                branchList={branchList}
                isBranchLoading={isBranchLoading}
                filters={filters}
                resetFilters={handleResetFilters}
                searchPlaceholder={t("user-name")}
              />
              {isLoading ? (
                <Loader />
              ) : !isEmpty ? (
                <>
                  <TableCommon
                    heading={tableHeading}
                    name={activeTab}
                    body={userList}
                    permissionToEdit={true}
                    tableStyle={{
                      minHeight: "40vh",
                      maxHeight: "40vh",
                    }}
                  />
                  <Paginate
                    totalPages={pagination.totalPages}
                    handleNextPage={handleNextPage}
                    currentPage={pagination.currentPage}
                  />
                </>
              ) : (
                <NoDataFound />
              )}
            </>
          )} */}
          {(permissionToViewEA ||
            permissionToManageEA ||
            permissionToViewEC ||
            permissionToManageEC) &&
            [BRANCH_ADMIN].includes(activeTab) && (
              <>
                <EgUserActionBar
                  handleChange={handleChangeFilters}
                  handleSubmit={handleRefresh}
                  orderByList={orderByList}
                  bankList={bankList}
                  productList={productList}
                  rolesList={rolesList.filter((elem) => elem.name !== END_USER)}
                  branchList={branchList}
                  isBranchLoading={isBranchLoading}
                  filters={filters}
                  resetFilters={handleResetFilters}
                  searchPlaceholder={t("user-name")}
                />
                {isLoading ? (
                  <Loader />
                ) : !isEmpty ? (
                  <>
                    <TableCommon
                      heading={tableHeading}
                      name={activeTab}
                      body={userList}
                      permissionToEdit={
                        permissionToManageEA || permissionToManageEC
                      }
                      tableStyle={{
                        minHeight: "40vh",
                        maxHeight: "40vh",
                      }}
                    />
                    <Paginate
                      totalPages={pagination.totalPages}
                      handleNextPage={handleNextPage}
                      currentPage={pagination.currentPage}
                    />
                  </>
                ) : (
                  <NoDataFound />
                )}
              </>
            )}{" "}
          {[BRANCH_CONSULTANT].includes(activeTab) &&
            (permissionToViewEU || permissionToManageEU) && (
              <>
                <EndUserActionBar
                  handleChange={handleChangeFilters}
                  handleSubmit={handleRefresh}
                  orderByList={orderByList}
                  bankList={bankList}
                  productList={productList}
                  rolesList={rolesList.filter((elem) => elem.name === END_USER)}
                  branchList={branchList}
                  isBranchLoading={isBranchLoading}
                  filters={filters}
                  resetFilters={handleResetFilters}
                  searchPlaceholder={t("user-name")}
                />
                {isLoading ? (
                  <Loader />
                ) : !isEmpty ? (
                  <>
                    <TableCommon
                      heading={tableHeading}
                      name={activeTab}
                      body={userList}
                      permissionToEdit={permissionToManageEU}
                      tableStyle={{
                        minHeight: "40vh",
                        maxHeight: "40vh",
                      }}
                    />
                    <Paginate
                      totalPages={pagination.totalPages}
                      handleNextPage={handleNextPage}
                      currentPage={pagination.currentPage}
                    />
                  </>
                ) : (
                  <NoDataFound />
                )}
              </>
            )}
        </div>
      </div>
      <BranchModalWrapper show={show}>
        <BranchDataStatusModal handleClose={handleClose} />
      </BranchModalWrapper>
    </div>
  );
};
export default UserListing;
